
import { lightColors, darkColors } from './colors';

export const lightTheme = {
    colors: lightColors,
  };
  
  export const darkTheme = {
    colors: darkColors,
  };